import * as React from 'react';
import { EPageTypes, EPlatformTypes, SimpleCall } from '@cian/frontend-newbuilding-call-component';

import { ApplicationContext } from '../../utils/applicationContext';
import { useSelector } from 'react-redux';
import {
  getNewbuildingPromoSnippetBuilders,
  getNewbuildingPromoSnippetSellers,
} from '../../selectors/newbuildingPromoSnippet';

interface ICallProps {
  onShowPhone(): void;
  onShowContacts(): void;
}

export function Call({ onShowPhone, onShowContacts }: ICallProps) {
  const context = React.useContext(ApplicationContext);
  const builders = useSelector(getNewbuildingPromoSnippetBuilders);
  const sellers = useSelector(getNewbuildingPromoSnippetSellers);
  const hasBuildersWithPhones = builders.some(builder => builder.phone?.number && builder.showPhone);
  const hasSellersWithPhones = sellers.some(seller => seller.phone?.number && seller.showPhone);
  const multiplePhoneButtonText = !hasSellersWithPhones
    ? 'Контакты застройщика'
    : !hasBuildersWithPhones
      ? 'Контакты продавца'
      : 'Показать контакты';

  return (
    <SimpleCall
      builders={builders}
      sellers={sellers}
      platformType={EPlatformTypes.WebDesktop}
      pageType={EPageTypes.NewbuildingList}
      httpApi={context.httpApi}
      logger={context.logger}
      onShowPhoneClick={onShowPhone}
      onOpenContactsClick={onShowContacts}
      multiplePhoneButtonText={multiplePhoneButtonText}
      showSinglePhoneInModal
      placeType="newbuildingPromoSnippetContacts"
    />
  );
}
